import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "@/store/index.js"
import axiosInstance from './utils/request.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import basicContainer from '@/components/common/basicContainer'
// 引入原始全局样式
import '@/assets/originCss/style.css'
import '@/assets/originCss/bootstrap.css'
import '@/assets/originCss/font-awesome.min.css'
import '@/assets/originCss/home.css'

//引入i18N
import i18n from '@/i18N/index'





Vue.config.productionTip = false
Vue.prototype.$http = axiosInstance
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value) 
}
).use(router)
Vue.component('basicContainer', basicContainer)

new Vue({
  render: h => h(App),
  i18n,
  router,
  store
}).$mount('#app')
